import { useAtom } from 'jotai';
import { useAtomValue } from 'jotai/utils';
import { useAiAgentAvailable } from 'src/hooks/useAiAgentAvailable';
import { useBudgetAllowed } from 'src/chat/BudgetIndicator';
import { aiAttentionDismissedAtom, chatOpenAtom } from 'src/shared/chat';

/**
 * Should the UI tastefully draw attention to the AI Agent? (#932)
 *
 * Active only when the agent is actually usable (addon + settings + backend)
 * AND the account has credits to spend (useBudgetAllowed) AND the user hasn't
 * already engaged (dismissed the coach mark or sent a prompt) AND the chat
 * panel isn't already open. Persisted per browser.
 */
export function useAiAttention(): { active: boolean; dismiss: () => void } {
  const { inAppAvailable, isLoading } = useAiAgentAvailable();
  const budgetAllowed = useBudgetAllowed();
  const [dismissed, setDismissed] = useAtom(aiAttentionDismissedAtom);
  const chatOpen = useAtomValue(chatOpenAtom);

  return {
    active: !isLoading && inAppAvailable && budgetAllowed && !dismissed && !chatOpen,
    dismiss: () => setDismissed(true),
  };
}

export default useAiAttention;
